import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconMoz(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <g fill="currentColor" stroke="none" strokeWidth="0" fillRule="evenodd">
        <path d="M1,12.6314479 L3.29183234,12.6314479 C3.52851549,12.6314479 3.72206878,12.4351023 3.72206878,12.1950046 L3.72206878,8.16679439 L8,13 L12.2781437,8.16679439 L12.2781437,12.1950046 C12.2781437,12.4351023 12.471697,12.6314479 12.7083801,12.6314479 L15,12.6314479 L15,4 L13.0540565,4 C12.4916684,4 12.07248,4.27479764 11.8459951,4.53041333 L8,8.87544902 L4.15400492,4.53041333 C3.92773242,4.27479764 3.50833156,4 2.94615595,4 L1,4 L1,12.6314479 Z"></path>
      </g>
    </Icon>
  )
}
